import { breakpoints } from '@styles/breakpoints';
import { mediumGrey, white } from '@styles/theme';
import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

const tablet = `screen and (min-width: ${breakpoints.tablet})`;

export const option = style({
  display: 'flex',
  cursor: 'pointer',
  boxSizing: 'border-box',
  containerType: 'inline-size',
  width: '100%',
  margin: 0,
  borderRadius: '5px',
  border: `1px solid ${themeVars.color.interactive.border}`,
  backgroundColor: white,
  transition: 'box-shadow 0.1s, border-color 0.1s',
  selectors: {
    '&:hover': {
      borderColor: 'transparent',
      boxShadow: `0 0 0 2px ${themeVars.color.interactive.ring}`,
    },
    '&:focus-visible': {
      outline: 'none',
      borderColor: 'transparent',
      boxShadow: `0 0 0 2px ${themeVars.color.interactive.ring}`,
    },
  },
});

export const body = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  '@media': {
    [tablet]: { padding: '1rem 2rem' },
  },
  '@container': {
    '(max-width: 15em)': { padding: '1rem' },
  },
});

export const optionSelected = style({
  border: `1px solid ${themeVars.color.interactive.selectedBorder}`,
  backgroundColor: themeVars.color.interactive.selectedBackground,
});

export const optionSpread = style({
  justifyContent: 'space-between',
  '@container': {
    '(max-width: 37.5em)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '0.5rem',
    },
  },
});

export const icon = style({
  width: '2rem',
  height: '2rem',
  flexShrink: 0,
  lineHeight: 0,
  textAlign: 'center',
});

export const label = style({
  fontWeight: 500,
});

export const labelBlock = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
});

export const labelWithInput = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  width: '100%',
  '@container': {
    '(min-width: 27.5em)': { flexDirection: 'row', alignItems: 'center' },
  },
});

export const silencedText = style({
  color: mediumGrey,
});

export const childInput = style({
  display: 'flex',
  width: '100%',
  '@container': {
    '(min-width: 27.5em)': { flex: 1, width: 'auto' },
  },
});

export const tags = style({
  display: 'flex',
  alignItems: 'center',
  gap: '0.625rem',
});
